import React from 'react';
import { Form, Input, InputNumber, Switch, Button } from 'antd';
import { Currency } from '../../api/currencyApi';
import { useTranslation } from 'react-i18next';

type Props = {
    initialValues?: Currency;
    onFinish: (values: Currency) => void;
    loading?: boolean;
};

const CurrencyForm: React.FC<Props> = ({ initialValues, onFinish, loading }) => {
    const { t } = useTranslation();
    return (
        <Form
            layout="vertical"
            initialValues={initialValues}
            onFinish={onFinish}
        >
            <Form.Item
                name="code"
                label={t('currency_code')}
                rules={[{ required: true, message: t('required_field') as string }]}
            >
                <Input placeholder={t('currency_code_placeholder', { example: 'USD, IQD, EUR' }) as string} />
            </Form.Item>
            <Form.Item
                name="symbol"
                label={t('symbol')}
                rules={[{ required: true, message: t('required_field') as string }]}
            >
                <Input placeholder={t('symbol_placeholder', { example: '$' }) as string} />
            </Form.Item>
            <Form.Item
                name="rateToIQD"
                label={t('rate_to_iqd')}
                rules={[{ required: true, message: t('required_field') as string }]}
            >
                <InputNumber min={0} step={0.0001} style={{ width: '100%' }} placeholder={t('rate_to_iqd_placeholder', { example: '1550' }) as string} />
            </Form.Item>
            <Form.Item
                name="isDefault"
                label={t('default_currency')}
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading} block>
                    {initialValues ? t('update') : t('create')}
                </Button>
            </Form.Item>
        </Form>
    );
};

export default CurrencyForm;